import React from 'react'
import Media from "../../../components/common/Media";
import { styled } from "../../../stitches.config";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';

type PhotoCardProps = {
    url: string
}

const PhotoCard = ({ url }: PhotoCardProps) => {
    return (
        <Card>
            <MediaWrapper>
                <Media src={url} disablePreload={true} />
            </MediaWrapper>
        </Card>
    )
}

export default PhotoCard

const Card = styled('div', {
    position: 'relative',
    width: 'auto',
    padding: '10px',
    height: '500px',
})

const MediaWrapper = styled('div', {
    width: '100%',
    height: '100%',
    'div': {
        backgroundColor: 'transparent',
        'picture': {
            'img': {
                objectFit: 'contain',
                objectPosition: '50% 50%',
            }
        }
    }
})